import { lazy, type ComponentType } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute } from '../utils/domain/routingComponents'
import { productDetailPageMarketplaceAccessControl } from '../access-control/storefrontAccess.configuration'

const MarketplaceProductDetailPageBuilderPage = lazy(
  () =>
    import(
      /* webpackChunkName: "MarketplaceProductDetailPageBuilderPage" */
      '../pages/product-detail/admin/MarketplaceProductDetailPageBuilderPage'
    )
)

const MarketplaceProductDetailPagesDashboardPage = lazy(
  () =>
    import(
      /* webpackChunkName: "MarketplaceProductDetailPagesDashboardPage" */
      '../pages/product-detail/admin/MarketplaceProductDetailPagesDashboardPage'
    )
)

// Retailer/partner-agnostic Instacart-admin routes for the Marketplace global PDP layout,
// on a clean admin base (/app/admin/storefront/product-detail-page) separate from the
// legacy `storefront-admin` (/app/admin/lps). Entry point is the "Product Detail Page"
// item on the Marketplace admin nav L1 — that lands on the dashboard, which lists the
// (singleton) global PDP page and exposes a "Create Global Product Page Layout" CTA when
// none exists. Gated by `productDetailPageMarketplaceAccessControl`
// (the `rt_product_detail_page_mp` toggle).
export const storefrontAdminProductDetailPageRouter = (
  <DomainRoute
    route="storefront-admin-product-detail-page"
    accessControl={productDetailPageMarketplaceAccessControl}
  >
    <DashSwitch>
      <DomainRoute
        exact
        route="storefront-admin-product-detail-page-edit"
        component={MarketplaceProductDetailPageBuilderPage as ComponentType<any>}
        accessControl={productDetailPageMarketplaceAccessControl}
      />
      <DomainRoute
        exact
        route="storefront-admin-product-detail-page"
        component={MarketplaceProductDetailPagesDashboardPage}
        accessControl={productDetailPageMarketplaceAccessControl}
      />
    </DashSwitch>
  </DomainRoute>
)
